import { render, staticRenderFns } from "./users.vue?vue&type=template&id=1afb559d&"
import script from "./js/users.js?vue&type=script&lang=js&"
export * from "./js/users.js?vue&type=script&lang=js&"
import style0 from "./users.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports